import React from "react";
import { ModeRendererProps } from "./types";

export function ShieldMode({ brand }: ModeRendererProps) {
  return (
    <g transform="translate(397 540)">
      <use href="#shield" fill={brand.deep} stroke={brand.white} strokeWidth="6" />
      {Array.from({ length: 6 }).map((_, i) => (
        <use
          key={i}
          href="#shield"
          fill="none"
          stroke={i % 3 === 0 ? brand.aqua : i % 3 === 1 ? brand.violet : brand.amber}
          strokeWidth={i % 2 ? 3 : 2}
          opacity={0.45 - i * 0.06}
          transform={`scale(${1 - i * 0.07})`}
        />
      ))}
      <use href="#shield" fill="url(#chevrons)" opacity="0.35" />
      <line x1="-120" y1="0" x2="120" y2="0" stroke={brand.violet} strokeWidth="4" />
      <line x1="0" y1="-120" x2="0" y2="120" stroke={brand.aqua} strokeWidth="4" />
      <circle r="26" fill={brand.deep} stroke={brand.amber} strokeWidth="5" />
    </g>
  );
}
